'use strict';

;( () => {

	document.addEventListener( 'alpine:init', () => {

		Alpine.data( 'gravityforms', () => ({

			init() {
				this.$el.querySelector( 'form' ).addEventListener( 'submit', () => {
					setTimeout( () => {
						window.location.href = `${window.location.href}?r=success`;
					}, 750 );
				});
			},
		}) );
	});
})();
